import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { CommunityDetailDataObject } from 'models/service';

type UpdateCommunityRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  cover_photo?: EntityReferenceRailsRequestData;
  description?: string;
  html_description?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const updateCommunity = async (communityId: string, data: UpdateCommunityRequest) =>
  apiClient.patch<CommunityDetailDataObject, ApiClientResponse<CommunityDetailDataObject>>(
    routes.community.update(communityId),
    {
      community: data,
    },
  );
